/**
 * Created by 1 on 2017/8/25.
 */
'use strict';
define([
    './AppEvent',
    './AppEvents',
    './Aop',
    './Draggable'
],function(
    AppEvent,
    AppEvents,
    Aop,
    Draggable
){
    /**
     * @ignore
     * @namespace
     * @memberOf G
     * @description 混合包
     */

    let misc ={
        AppEvent:AppEvent,
        AppEvents:AppEvents,
        Draggable:Draggable
    }
    return misc;
});